import { useRouterState } from '@tanstack/react-router';

import { TradingShellScreen } from './TradingShellScreen';

export function AppShellScreen() {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });
  return (
    <TradingShellScreen
      asset={readPendingTradeAsset(pathname)}
      message="Loading market..."
    />
  );
}

function readPendingTradeAsset(pathname: string) {
  const tradePathPrefix = '/trade/';

  if (!pathname.startsWith(tradePathPrefix)) {
    return 'BTC';
  }

  const asset = pathname.slice(tradePathPrefix.length);

  if (asset.length === 0) {
    return 'BTC';
  }

  return decodeURIComponent(asset);
}
